const CARDAPIO_BASE = process.env.REACT_APP_CARDAPIO_URL;

export function getCardapioUrl(menuCode) {
  if (!menuCode || !CARDAPIO_BASE) return null;
  return `${CARDAPIO_BASE.replace(/\/$/, '')}/estabelecimento/${menuCode}`;
}
